import PlantAnalyserScreen from '../shared/PlantAnalyserScreen';

export default function VendorPlantList() {
  return <PlantAnalyserScreen role="vendor" />;
}
